import {get_key} from "../../../search/util.js";

export function formatDrugResults(searchResults, gSnapshot, tSnapshot) {
    return searchResults.drugs.map((drugResult) => {
        const {
            d: title,
        } = drugResult;

        const resultPath = get_key(gSnapshot.map, "i", drugResult.i);

        let guidelineName = drugResult.g;
        if (guidelineName === undefined) {
            Object.keys(window.tgg.guidelines).forEach((key) => {
                if (window.tgg.guidelines[key][resultPath] !== undefined) {
                    guidelineName = key.replace(/_/g, " ");
                }
            });
        } else {
            guidelineName = guidelineName.replace(/_/g, " ");
        }

        let topicPath = get_key(tSnapshot.map, "i", drugResult.t);
        try {
            topicPath = Object.keys(topicPath).filter(key => window.tgg.topics[guidelineName][key].i === drugResult.t)[0];
        } catch (error) {
        }

        const drugKey = Object.keys(drugResult.d)[0];
        const url = `/viewTopic?etgAccess=true&guidelinePage=${encodeURIComponent(guidelineName)}&topicfile=${encodeURIComponent(topicPath)}.ditamap#${resultPath}|${drugKey}`
        const drugName = title.includes(' - ') ? title.split(' - ')[0] : title;

        return {
            drugName: drugName,
            fullText: title,
            url: url,
            guideline: guidelineName,
            score: 0,
        }
    });
}